<!-- eslint-disable max-len -->
<script setup lang='ts'>
import { computed } from 'vue'
import { screenModule } from '@/store/screen/module'
import UIKit from '@pocketprep/ui-kit'

const {
    Button: PocketButton,
    Icon,
} = UIKit

const emit = defineEmits<{
    'tryAQuestion': []
}>()

const breakpoint = computed(() => {
    return screenModule.getters.getBreakpoint()
})

</script>

<template>
    <div class="pass-with-confidence">
        <div class="pass-with-confidence__banner">
            <img
                class="pass-with-confidence__half-tone"
                src="@/assets/register-onboard/try-a-question/banner-half-tone.png"
                alt=""
            />
            <Icon class="pass-with-confidence__star" type="star" />
            <div class="pass-with-confidence__banner-text">
                Our prep is quiz-based for flexible practice to get you exam ready.
            </div>
        </div>
        <div
            v-if="breakpoint === 'black-bear'"
            class="pass-with-confidence__we-got-you-text"
        >
            We've got you covered, from quick quizzes to full length mock exams.
        </div>
        <img
            v-if="breakpoint === 'black-bear'"
            class="pass-with-confidence__quiz-mode-image-mobile"
            src="@/assets/register-onboard/try-a-question/quiz-mode-list-mobile.png"
            alt=""
        />
        <img
            v-else
            class="pass-with-confidence__quiz-mode-image"
            src="@/assets/register-onboard/try-a-question/quiz-mode-list.png"
            alt=""
        />
        <div class="pass-with-confidence__accent-message-left">
            Quick quizzes to mock exams.
        </div>
        <PocketButton
            class="pass-with-confidence__try-a-question-btn"
            @click="emit('tryAQuestion')"
        >
            Try a Question<Icon class="pass-with-confidence__try-a-question-btn-arrow" type="arrow" />
        </PocketButton>
    </div>
</template>

<style lang='scss' scoped>
.pass-with-confidence {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__banner {
        position: relative;
        display: flex;
        width: 260px;
        padding: 21px 12px 16px 12px;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid $butterscotch;
        background: $buttermilk;
        margin-top: 24px;
        margin-bottom: 32px;

        @include breakpoint(black-bear) {
            margin-bottom: 32px;
        }
    }

    &__banner-text {
        position: relative;
        z-index: 1;
        margin: 0;
        color: $brand-black;
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        line-height: 22px;
    }

    &__half-tone {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        pointer-events: none;
    }

    &__star {
        position: absolute;
        top: 4px;
        left: -18px;
        width: 26px;
        height: 26px;
        z-index: 3;
        pointer-events: none;
        color: $caramel;
    }

    &__we-got-you-text {
        width: 272px;
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        margin-bottom: 16px;
    }

    &__quiz-mode-image-mobile {
        width: 294px;
        height: 344px;
    }

    &__quiz-mode-image {
        width: 679px;
        height: 320px;
    }

    &__accent-message-left {
        position: absolute;
        top: 330px;
        left: 220px;
        width: 98px;
        font-size: 13px;
        line-height: 18px;

        &::before {
            content: '';
            position: absolute;
            right: -70px;
            top: -30px;
            background: url('@/assets/onboarding/tip-arrow.svg') no-repeat center center;
            width: 65px;
            height: 14px;
            transform: rotate(10deg) scaleX(-1);
        }

        @include breakpoint(brown-bear) {
            top: 332px;
            left: 90px;
        }

        @include breakpoint(black-bear) {
            display: none;
        }
    }

    &__try-a-question-btn {
        margin-top: 24px;
        margin-bottom: 32px;
    }

    &__try-a-question-btn-arrow {
        margin-left: 8px;
    }
}
</style>
